import SalesAnalyticsCountry from "@/components/analytics/salesAnalytics/country/Country";
import SalesAnalyticsCountryBrand from "@/components/analytics/salesAnalytics/countryBrand/CountryBrand";

export const analytics = [
    {path: '/analytics/sales-analytics/country', name: 'analytics', component: SalesAnalyticsCountry},
    {path: '/analytics/sales-analytics/country-brand', name: 'salesAnalyticsCountryBrand', component: SalesAnalyticsCountryBrand},
]